//  ? 色值格式校验
export function validColor(rule, value, callback) {
  let reg = /^#[0-9a-fA-F]{6}$/;
  if (!value) {
    console.log("vvvv:", value);
    callback(new Error("请输入色值"));
  } else {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确格式的色值(如#ffffff)"));
    }
  }
}

// ? 手机号规则校验
export function validMobile(rule, value, callback) {
  let reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
  if (!value) {
    callback(new Error("请输入手机号"));
  } else {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确格式的手机号"));
    }
  }
}

export function validatorTrainDays(rule, value, callback) {
  if (value <= 0) {
    callback(new Error("请输入大于0的数字"));
  } else if (!value) {
    callback(new Error("请输入培训天数"));
  } else  {
    callback();
  }
}
